/*
 * Copyright (c) 2026 Macrofocus GmbH. All Rights Reserved.
 */
package com.macrofocus.high_d.parallelcoordinates

import org.mkui.canvas.CPCanvas
import org.mkui.color.colorOf
import org.mkui.font.CPFontFactory
import org.mkui.font.MkFont
import org.mkui.font.Weight
import org.mkui.geom.Point2D
import org.mkui.geom.Rectangle
import org.mkui.graphics.AbstractIDrawing
import org.mkui.graphics.IGraphics

/**
 * A value on a half transparent gray background (AlphaJLabel), shown next to a handle of the range slider of an axis
 * while the mouse is over it, as PopupAxisController.showSliderValues.
 */
class RangeBubbleView : CPCanvas() {
    var text: String = ""
        set(value) {
            if (field != value) {
                field = value
                drawing.changed()
            }
        }

    private val drawing = object : AbstractIDrawing() {
        override fun draw(g: IGraphics, point: Point2D?, width: Double, height: Double, clipBounds: Rectangle) {
            if (text.isEmpty()) {
                return
            }
            g.setFont(FONT)
            val textWidth = g.getStringWidth(text)
            g.setColor(colorOf(128, 128, 128, 128))
            g.fillRectangle(0, 0, textWidth.toInt() + 3, height.toInt())
            g.setColor(colorOf(0, 0, 0))
            g.setTextBaseline(IGraphics.TextBaseline.Middle)
            g.drawString(text, 1.5f, (height / 2).toFloat())
        }

        fun changed() {
            notifyIDrawingChanged()
        }
    }

    init {
        addLayer(drawing)
    }

    companion object {
        const val WIDTH = 80.0
        const val HEIGHT = 16.0

        private val FONT: MkFont? by lazy { CPFontFactory.instance.createFont(null, Weight.NORMAL, 12) }
    }
}
